import { ViewType } from '../../general';

export interface ViewSwicherOptionModel {
  tooltip: string;
  type: ViewType;
  icon: string;
  isActive?: boolean;
}